import {
  scan,
  cancelScan,
  getMemberTicket,
  redeemTicket,
  addValue,
  cardLinkDeduct,
  validatePhoneMember,
  setPhoneMemberIntoOrder,
  queryMemberInfoByPhone,
  getMemberTicketByPhone,
} from '@/api/member';
import { useTicket } from '@/api/order';

export default {
  namespaced: true,
  state: {
    isMember: false,
    memberPhone: '',
    memberInformation: null,
    // memberInformation: {
    //   level_description: '尊爵會員',
    //   card_no: '1234',
    //   name: 'wanwan',
    //   birthday: '生日快樂',
    // },
    dayungsPayment: null,
    // dayungsPayment: {
    //   want_card: {
    //     payment_type: 'want_card',
    //     card_no: '199001',
    //     balance: 200,
    //     will_expired_balance: 0,
    //   },
    //   want_card_point: {
    //     payment_type: 'want_card_point',
    //     card_no: '199001',
    //     balance: 30,
    //     will_expired_balance: 10,
    //   },
    //   cash_card: {
    //     payment_type: 'cash_card',
    //     card_no: '199777',
    //     balance: 199,
    //     will_expired_balance: 0,
    //   },
    // },
    voucherList: null,
    // voucherList: [
    //   {
    //     voucher_set_id: '0093541655900',
    //     voucher_id: '20221123110150045940360b3870',
    //     buy_drink_name: '莓好時光(M)商品券-不限定+可加入購物車+可轉贈',
    //     start_date: '20221121100000',
    //     end_date: '20221231235555',
    //     redemption_start_date: '20221121100000',
    //     redemption_end_date: '20221231235555',
    //   },
    // ],
    couponList: null,
    // couponList: [
    //   {
    //     coupon_set_id: '1645424858492',
    //     coupon_id: '20221213151719022ff1ebef1d73',
    //     title: '鮮搾橘子紅茶',
    //     start_date: '20221211163419',
    //     end_date: '20221231163519',
    //     redemption_start_date: '20221211163424',
    //     redemption_end_date: '20221231163524',
    //   },
    // ],
    showJoinMemberDialog: false,
  },

  getters: {
    getMemberPhone: (state) => state.memberPhone,
    getIsMember: (state) => state.isMember,
    getMemberInformation: (state) => state.memberInformation,
    getDayungsPayment: (state) => state.dayungsPayment,
    getWantCardNo: (state) => {
      if (state.dayungsPayment?.want_card) return state.dayungsPayment.want_card.card_no;
      else return '';
    },
    getVoucherList: (state) => state.voucherList,
    getCouponList: (state) => state.couponList,
    getMemberTicket: (state) => {
      if (state.voucherList?.length > 0 || state.couponList?.length > 0) return true;
      else return false;
    },
    isPhoneMember: (state) => {
      if ( state.memberPhone?.length > 5 && state.memberInformation?.card_no) {
        return true;
      }
      else {
        return false;
      }
    },
    getMemberId: (state) => state.memberInformation?.card_no,
    getIsQueryMemberTicket: (state) => state.isQueryMemberTicket,
    getShowJoinDialog: (state) => state.showJoinMemberDialog,
  },

  mutations: {
    SET_MEMBER_PHONE(state, data) {
      state.memberPhone = data;
    },
    SET_IS_MEMBER(state, data) {
      state.isMember = data;
    },
    SET_MEMBER(state, data) {
      state.memberInformation = data;
      if (!data) {
        state.voucherList = null;
        state.couponList = null;
      }
    },
    SET_DAYUNGS_PAYMENT(state, data) {
      state.dayungsPayment = data;
    },
    SET_TICKET(state, data) {
      state.voucherList = data.voucher_list;
      state.couponList = data.coupon_list;
      state.isQueryMemberTicket = true;
    },
    SET_WANT_CARD(state, data) {
      state.dayungsPayment.want_card = data;
    },
    RESET(state) {
      state.memberInformation = null;
      state.dayungsPayment = null;
      state.voucherList = null;
      state.couponList = null;
      state.isQueryMemberTicket = false;
      state.memberPhone = '';
    },
    SET_SHOW_JOIN_MEMBER_DIALOG(state) {
      state.showJoinMemberDialog = true;
    },
    CLOSE_JOIN_MEMBER_DIALOG(state) {
      state.showJoinMemberDialog = false;
    },
  },

  actions: {
    doSetMemberPhone({ commit, getters, rootGetters }, phone) {
      commit('SET_MEMBER_PHONE', phone);
    },
    async doCheckMember({ commit, getters, rootGetters, dispatch }, phone) {
      commit('RESET'); //重置
      const data = {
        order_id: rootGetters['order/getOrderId'],
        cell_phone: phone,
      };
      const res = await validatePhoneMember(data);
      if (res) {
        commit('SET_IS_MEMBER', res.is_exist);

        // 使用 getter 來取得方法
        if (!res.is_exist) {
          console.log('SET_SHOW_JOIN_MEMBER_DIALOG');
          //非會員 需要把門號記錄起來
          commit('SET_MEMBER_PHONE', phone);
          commit('SET_SHOW_JOIN_MEMBER_DIALOG');
        } else {
          //如果他是會員，查詢他對應的會員資料跟票券
          commit('SET_MEMBER_PHONE', phone);
          await dispatch('doSetPhoneMemberIntoOrder', false);
          await dispatch('doQueryMemberInfoByPhone', {
            order_id: rootGetters['order/getOrderId'],
            cell_phone: phone,
          });
        }
        return res;
      }
      return null;
    },
    async doSetPhoneMemberIntoOrder({ commit, getters, rootGetters }, register) {
      const data = {
        order_id: rootGetters['order/getOrderId'],
        cell_phone: getters.getMemberPhone,
        is_member: getters.getIsMember,
        auto_register: register,
      };
      const res = await setPhoneMemberIntoOrder(data);
      return res;
    },

    async doQueryMemberInfoByPhone({ commit, getters, rootGetters, dispatch }, { order_id, cell_phone }) {
      try {
        const res = await queryMemberInfoByPhone({ order_id, cell_phone });
        if (res.payment) commit('SET_DAYUNGS_PAYMENT', res.payment);
        const carrier = rootGetters['checkout/getCarrier'];
        if (res.carrier) { //無條件變成目前查詢回來的會員手機載具
          commit('checkout/SET_CARRIER', res.carrier, { root: true });
        }
        else {
          commit('checkout/CLEAR_CARRIER', 4, { root: true }); //清空
        }
        if (res.member_card) {
          commit('SET_MEMBER', res.member_card);
          if (!getters.getIsQueryMemberTicket && order_id) {
            await dispatch('doGetMemberTicketByPhone', { order_id, cell_phone });
          }
        }
      } catch (error) {
        console.debug('doQueryMemberInfoByPhone error' + error);
      }
    },

    //掃描旺卡與會員卡資訊
    async doQueryCard({ commit, getters, rootGetters }) {
      const order_id = rootGetters['order/getOrderId'];
      const member_id = order_id ? getters.getMemberInformation?.card_no || '' : '';
      const card_no = order_id ? getters.getDayungsPayment?.want_card?.card_no || '' : '';
      const res = await scan({ scan_method: 1, test_mode: 0, order_id, member_id, card_no });
      commit('RESET');
      if (res.payment) commit('SET_DAYUNGS_PAYMENT', res.payment);
      const carrier = rootGetters['checkout/getCarrier'];
      if (res.carrier && carrier?.length === 0) {
        commit('checkout/SET_CARRIER', res.carrier, { root: true });
      }
      if (res.member_card) {
        commit('SET_MEMBER', res.member_card);
        if (!getters.getIsQueryMemberTicket && order_id) {
          const ticket = await getMemberTicket({ order_id, member_id: res.member_card.card_no });
          commit('SET_TICKET', ticket);
        }
      }

      return Promise.resolve();
    },
    //核銷會員的電子券
    async doRedeemTicket({ commit, rootGetters }, data) {
      const order_id = rootGetters['order/getOrderId'];
      const res = await redeemTicket({ ...data, order_id });
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('cart/SET_CART_DATA', res.cart, { root: true });
      return Promise.resolve();
    },
    //掃描電子券
    async doQueryTicket({ commit, getters, rootGetters }) {
      const order_id = rootGetters['order/getOrderId'];
      const member_id = getters.getMemberInformation?.card_no || '';
      const card_no = getters.getDayungsPayment?.want_card?.card_no || '';
      const res = await scan({ scan_method: 6, test_mode: 0, order_id, member_id, card_no });
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('cart/SET_CART_DATA', res.cart, { root: true });
      if (res.member_card) commit('SET_MEMBER', res.member_card);
      if (res.card_info) commit('SET_DAYUNGS_PAYMENT', res.card_info);
      const carrier = rootGetters['checkout/getCarrier'];
      if (res.invoice_info.carrier.length > 0 && carrier.length === 0) {
        commit('checkout/SET_CARRIER', res.invoice_info.carrier[0], { root: true });
      }
      return Promise.resolve();
    },
    //選擇一張電子券(套餐)
    async doUseTicket({ commit, rootGetters }, ticket_id) {
      const data = {
        order_id: rootGetters['order/getOrderId'],
        ...ticket_id,
      };
      const res = await useTicket(data);
      commit('checkout/SET_TRANSACTION', res.transaction, { root: true });
      commit('cart/SET_CART_DATA', res.cart, { root: true });
      return Promise.resolve();
    },
    //取消掃描
    async doCancelScan({ rootGetters }, type) {
      const order_id = rootGetters['order/getOrderId'];
      await cancelScan(type, order_id);
      return Promise.resolve();
    },
    //旺卡加值
    async doAddCardVale({ commit }, data) {
      const { status, payment } = await addValue(data);
      if (!status) return;
      // console.log(payment);
      commit('SET_WANT_CARD', payment.want_card);
      return Promise.resolve();
    },
    //旺卡自動加值
    async doCardLinkDeduct({ commit }, data) {
      const { status, payment } = await cardLinkDeduct(data);
      if (!status) return;
      commit('SET_WANT_CARD', payment.want_card);
      return Promise.resolve();
    },
    async doCloseJoinDialog({ commit }) {
      commit('CLOSE_JOIN_MEMBER_DIALOG');
    },

    async doGetMemberTicketByPhone({ commit }, { order_id, cell_phone }) {
      try {
        const ticket = await getMemberTicketByPhone({ order_id, cell_phone });
        commit('SET_TICKET', ticket);
      } catch (error) {
        console.error('Error fetching member ticket:', error);
      }
    },
  },
};
